<template>
    <div class="login-wrap">
        <div class="dialog" id="dialog">
            <div class="title">
                <h2> 联 迅 科 技 统 一 身 份 认 证</h2>
                <p>汇 融 天 下 门 户</p>  
                
            </div>
            <div class="login">
                <div>
                    <i class="iconfont icon-zhanghao"></i>
                    <input id="inp" class='inp' type="text" v-model="account" placeholder="请输入您的账号" >
                </div>
                <p class="tips">请输入正确的账号格式！</p>
                <div>
                    <i class="iconfont icon-mima"></i>
                    <input id="inp2" class='inp' type="text" v-model="password" placeholder="请输入您的密码">
                </div>
                <p class="tips">密码错误, 请检查！</p>
            </div>
            <div class="register">
                <a href="#">注册账号</a>
                <a href="#">重置密码</a>
            </div>
            <div class="submit">
                <button @click="onLogin">登录</button>
            </div>
        </div>
    </div>
</template>

<script>
import cryptoAES from '../utils/cryptoAES'
    export default {
        data() {
            return {
                account:null,
                password:null
            }
        },
        mounted () {
            this.mouseInteraction();
            this.check();
        },
        methods: {
            //验证是否登录
            check () {
                this.$http.get('/web/base/check').then(data=>{
                    if (data.data.info) {
                        let cutURL = decodeURIComponent(location.href.split('=')[1]);
                        if(cutURL.indexOf('http')!= -1) {
                            window.location.href = "/sso/auth?redirect=" + cutURL
                        }else {
                            this.$router.push('/home')
                        }
                    }
                })
            } ,
            // 登录
            onLogin () {
                let word = this.account + '|' + this.password + '|' + '1';
                let loginToken = cryptoAES.encrypt(word);
                this.$http.get('/web/base/doLogin', {
                    params: {
                        loginToken: loginToken
                    }
                }).then(data=>{
                    if(data.data.status){
                        let cutURL = decodeURIComponent(location.href.split('=')[1]);
                        if(cutURL.indexOf('http')!= -1) {
                            console.log(window.location.host)
                            window.location.href = "/sso/auth?redirect=" + cutURL
                        }else {
                            this.$router.push('/home')
                        }
                    }else{
                        alert("用户名或密码错误")
                    }
                })


            },
            // 鼠标感应
            mouseInteraction() {
                let config = {
                    perspective: 600, 
                    distance: 10, 
                    rotation: 0.2,
                    startX: 0,
                    startY: 0
                }
                let oDialog = document.getElementById('dialog');
                let inps = document.getElementsByClassName('inp');

                // 操作元素
                let animate3dEle =  function (element,distance,rotationMultiple,startX,startY ){
                    // 获取元素的位置以及宽高
                    let eleTop, eleLeft, eleWidth, eleHeight;
                    eleTop = element.offsetTop;
                    eleLeft = element.offsetLeft;
                    eleWidth = element.offsetWidth;
                    eleHeight = element.offsetHeight;
                    let move = function(event){
                        
                        // 计算鼠标位置并设置倾斜和移动
                        let pctX = ((event.pageX - eleLeft)/eleWidth) - 0.5 + startX;
                        let pctY = ((event.pageY - eleTop)/eleHeight) - 0.5 + startY;
                        clacAnimate(this, pctX, pctY, rotationMultiple, distance, setCssStyles);
                
                    };
                    
                    clacAnimate(element,startX, startY, rotationMultiple,distance,setCssStyles);

                    
                    for(let i=0 ;i<inps.length; i++){
                        inps[i].onfocus = function(){
        
                        if(document.activeElement.id == 'inp' || document.activeElement.id == 'inp2' || document.activeElement.id == 'inp3' ){
                                element.removeEventListener('mousemove',move)
                        }
                        }
                    }
                    element.addEventListener('click',function(event){
                        // 防止点击的是input框
                        if(event.target.id == 'dialog'){
                            // 再次开启
                            // 鼠标移动
                            element.addEventListener('mousemove',move)
                            
                            // 鼠标滑出归位
                            element.addEventListener('mouseleave',function(){
                                clacAnimate(this, startX, startY, rotationMultiple, distance, setCssStyles);
                            })
                        }
                    })

                    // 鼠标移动
                    element.addEventListener('mousemove',move)
                    
                    // 鼠标滑出归位
                    element.addEventListener('mouseleave',function(){
                        clacAnimate(this, startX, startY, rotationMultiple, distance, setCssStyles);
                    })
                    
                }

                // 计算平移和旋转
                function clacAnimate(element, pctX,pctY, rotationMultiple,distance,cb){
                    let rotateX = pctY * rotationMultiple * -180;
                    let rotateY = pctX * rotationMultiple * 180;
                    let translateX = pctX * distance;
                    let translateY = pctY * distance; 

                    Array.from(element.children).forEach(function(item, index){
                        cb(element,index,translateX, translateY, rotateX, rotateY );
                    })
                }

                // 通过计算平移结果后设置样式
                function setCssStyles(element, index, translateX, translateY,rotateX, rotateY,distance){
                
                    let x = translateX * index;
                    let y = translateY * index;

                    element.style.transform = "translate(" + x + "px," + y + "px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
                    element.style.cssText = "-webkit-transform: translate(" + x + "px," + y + "px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
                }
                animate3dEle(oDialog, config.distance, config.rotation, config.startX, config.startY )
            
            },
 

        }
    }
</script>

<style lang="less" scoped>
        .login-wrap {
            width: 100%;
            height: 100%;
            background: url('../assets/timg5.jpg')no-repeat center;
            background-size: cover;
            position: relative;
            overflow: hidden;;

        }
        .dialog {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            width: 520px;
            height: 640px;
            color: #fff;
            font-size: 34px;
            text-align: center;
            box-sizing: border-box;
            border-radius: 8px;
            background: rgba(255, 255, 255, .3);
            box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, .3);
            overflow: hidden;
            cursor: pointer;
        }
        .dialog::before {
            background:url('../assets/timg5.jpg')no-repeat center;
            background: cover;
            content: '';
            position: absolute;;
            top: 0; bottom: 0;
            left: 0; right: 0;
            -webkit-filter: blur(10px); /* Chrome, Opera */
            -moz-filter: blur(10px);
                -ms-filter: blur(10px);    
                    filter: blur(10px);
            filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=10, MakeShadow=false); /* IE6~IE9 */
            z-index: -1;
        }
        .dialog .title {
            margin-top: 72px;
            margin-bottom: 62px;
        }
        .dialog .title h2 {
            margin-bottom: 20px;
            text-shadow: 4px 4px 8px #fff;
            font-size: 32px;
        }
        .dialog .title p {
            font-size: 22px;
        }
        .dialog .login div {
            display: flex;
            align-items: center;
            margin: 32px 90px 0;
            border-bottom: 2px solid #fff;
            text-align: left;
      
        }
        .dialog .login div input {
            padding: 12px 0;
            background: transparent;
            outline: none;
            border: none;
            font-size: 18px;
            color: #fff;
            font-weight: 600;
            letter-spacing: 1px;
        }
        .dialog .login div i {
            margin-right: 12px;
            font-size: 24px;
            font-weight: 700;
        }
        .dialog .login .tips {
            margin-top: 10px;
            padding: 0 90px;
            font-size: 14px;
            color: rgb(255, 59, 59);
            text-align: left;
            display: none;
        }
        ::-webkit-input-placeholder { /* Chrome/Opera/Safari */ 
			color: #fff;
		}
		::-moz-placeholder { /* Firefox 19+ */  
			color: #fff;
		}
		:-ms-input-placeholder { /* IE 10+ */ 
		 color: #fff;
		}
		:-moz-placeholder { /* Firefox 18- */ 
		 color: #fff;
		}
        .register {
            margin: 0 90px;
            text-align: right;
        }
        .register a {
            padding: 0 0 0 6px;
            color: #fff;
            text-decoration: none;
            font-size: 16px;
        }
        .register a:hover {
            text-shadow: 0 0 6px #fff;
        }
        .submit {
            margin: 70px 90px 0;
            -webkit-box-reflect: below 1px -webkit-gradient(linear, left top, left bottom , from(transparent), color-stop(10%,transparent),to(rgba(250,250,250,.3)));
            overflow: hidden;
        }
        .submit button {
            width: 98%;
            height: 40px;
            color: rgba(255, 255, 255, 0.938);
            font-size: 18px;
            font-weight: 700;
            border-radius: 40px;
            border: none;
            outline: none;
            cursor: pointer;
            letter-spacing: 4px;
            background:rgb(112, 202, 238);
            box-shadow: 0 1px 2px 1px rgb(87, 200, 245);
            transition: all 200ms ease-in-out;
        }
        .submit button:hover {
            background:rgb(243, 92, 92);
            box-shadow: 0 1px 2px 1px rgb(243, 92, 92);
        }
</style>